const getSizeValue = (value) => {
  return typeof value === 'number' ? `${value}px` : value;
};

const shouldRemovePaddingForBodyCell = (columnDefinition) => {
  const hasCustomRowCell = !!columnDefinition?.row?.cell && typeof columnDefinition.row.cell !== 'function';
  const hasCustomRowClass = !!columnDefinition?.row?.class;
  return hasCustomRowCell && !hasCustomRowClass;
};

const mapFromLegacyColumnDefinitions = (columnDefinition, props, isSubRows = false) => {
  const dataSbAutomation = props.rowEditor
    ? `${isSubRows ? 'subrow-' : ''}cell-editor-${columnDefinition.field}`
    : `${isSubRows ? 'subrow-' : ''}cell-${columnDefinition.field}`;
  const column = {
    header: { name: columnDefinition.name },
    row: { field: columnDefinition.field, dataSbAutomation },
  };

  if (columnDefinition.cell) {
    column.row.cell = columnDefinition.cell;
  }

  if (columnDefinition.meta) {
    column.row.meta = columnDefinition.meta;
  }

  if (columnDefinition.size) {
    column.style = {
      width: getSizeValue(columnDefinition.size),
    };
  }

  if (columnDefinition.class) {
    if (columnDefinition.class.header) {
      column.header.class = columnDefinition.class.header;
    }

    if (columnDefinition.class.cell) {
      column.row.class = columnDefinition.class.cell;
    }
  }

  if (columnDefinition.header?.cell) column.header.cell = columnDefinition.header.cell;

  return column;
};

export const mapToPrimevueColumns = (columnDefinitions, props, isSubRows = false) => {
  const columns = [];

  columns.push(
    ...columnDefinitions.map((columnDefinition) => {
      let column = {};

      if (!isSubRows) {
        if (props.apiSorting) {
          const sortable = columnDefinition.sortingFn && columnDefinition.sortingFn !== 'OFF';

          if (sortable !== undefined && sortable !== null) {
            column.sortable = sortable;
          }

          if (columnDefinition.sortingState) {
            column.sortingState = columnDefinition.sortingState;
          }
        } else {
          const sortable = (columnDefinition.sortingFn !== false || columnDefinition.sortingFn === undefined) && columnDefinition.sortingFn !== 'OFF';

          if (sortable !== undefined && sortable !== null) {
            column.sortable = sortable;
          }
        }
      }

      if (columnDefinition.frozen) column.frozen = columnDefinition.frozen;
      if (columnDefinition.alignFrozen) column.alignFrozen = columnDefinition.alignFrozen;
      if (columnDefinition.size) {
        column.style = {
          width: getSizeValue(columnDefinition.size),
        };
      }

      if (columnDefinition.row && columnDefinition.header) {
        const dataSbAutomation = props.rowEditor
          ? `${isSubRows ? 'subrow-' : ''}cell-editor-${columnDefinition.row.field}`
          : `${isSubRows ? 'subrow-' : ''}cell-${columnDefinition.row.field}`;

        if (columnDefinition.meta) {
          column.meta = columnDefinition.meta;
        }

        column = {
          row: {
            ...columnDefinition.row,
            ...column.row,
            dataSbAutomation,
          },
          header: {
            ...column.header,
            ...columnDefinition.header,
          },
          ...column,
        };
      } else {
        column = {
          ...mapFromLegacyColumnDefinitions(columnDefinition, props, isSubRows),
          ...column,
        };
      }

      if (columnDefinition.minSize) {
        column.header.style = {
          minWidth: getSizeValue(columnDefinition.minSize),
        };
        column.row.style = {
          minWidth: getSizeValue(columnDefinition.minSize),
        };
      }

      if (columnDefinition.maxSize) {
        column.header.style = {
          ...column.header.style,
          maxWidth: getSizeValue(columnDefinition.maxSize),
        };
        column.row.style = {
          ...column.row.style,
          maxWidth: getSizeValue(columnDefinition.maxSize),
        };
      }

      if (shouldRemovePaddingForBodyCell(columnDefinition)) {
        column.row.style = {
          ...column.row.style,
          padding: 0,
        };
      } else if (columnDefinition.row?.editable && !!props.editMode) {
        column.row.style = {
          ...column.row.style,
          padding: 'var(--p-datatable-body-cell-edit-padding)',
        };
      }

      return column;
    }),
  );

  return columns;
};
